import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=0a98c451"
import script from "./GroupDetail.vue?vue&type=script&lang=ts"
export * from "./GroupDetail.vue?vue&type=script&lang=ts"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=0a98c451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports